
import service from '@/utils/axios.js';

//获取测评列表
export const getEvaluationList = (data) => {
  return service.get('/api/evaluation/list',data);
};
//获取测评详情
export const getQuestionQuery = ( data) => {
  return service.get('/api/evaluation/question/query?evaluationBasicId='+data.evaluationBasicId);
};
//提交测评
export const evaluationSubmit = ( data) => {
  return service.post('/api/evaluation/singleTypeSelect/submit',data);
};
//获取报告列表
export const getReportList = ( data) => {
  return service.post('/api/evaluation/hisreport/list',data);
};
//获取obs参数
export const getObsParams = ( data) => {
  return service.get('/api/storage/upload/signature');
};
//获取我的测评报告
export const getMyReport = ( data) => {
  return service.post('/api/evaluation/report/detail',data);
};
//获取测评单品信息
export const getProductSingle = ( data) => {
  return service.post('/api/product/single/detail/query',data);
};
//保存附件
export const saveResume = ( data) => {
  return service.post('/api/attachment/resume',data);
};

//编辑附件
export const editResume = ( data) => {
  return service.put('/api/attachment/resume',data);
};

//查询助力订单
export const checkOrder = ( data) => {
  return service.post('/api/share/help/order/qry',data);
};
//创建助力订单
export const createOrder = ( data) => {
  return service.post('/api/share/help/order/init',data);
};
//刷新token
export const postRefreshTokenApi = ( data) => {
  return service.post('/api/refresh/token',data);
};

// 获取用户当前月剩余权益
export const getUserRights = ( data) => {
  return service.get('/api/userRights/queryRights?productCode=' + data.productCode);
};

// 权益使用
export const postUserRightsUse = ( data) => {
  return service.post('/api/userRights/use', data);
};

export const getResumeData = ( data) => {
  let url = '/api/resume/detail'
  if(data.resumeId){
    url = url +'/'+data.resumeId
  }
  return service.get(url);
};

// 获取简历诊断报告
export const getResumeDiagnosis = (data) => {
  return service.get('/api/resume/diagnosis/report?diagnosisId=' + data.id);
};

// 去诊断
export const postResumeDiagnosis = (data) => {
  return service.post('/api/resume/diagnosis', data);
};
//获取职位适配分析报告
export const getAaptReport = (params) => {
  return service.get(`api/job/adapt/detail/${params.id}`);
};



// WEBPACK FOOTER //
// ./src/api/api.js